/* Kove & Co bundle picker
 * - Tile 0 = the bag on its own: the theme's normal add to cart runs untouched.
 * - Any other tile: the product form submit is intercepted and every item in the
 *   offer is added in one /cart/add.js call, tagged with a hidden _bundle property.
 * - Inside a bundle tile, the bag colour swatches just select a colour (no page change).
 * - Prices shown are a preview; Shopify Discounts apply the real discount at checkout.
 */
(function () {
  if (window.__kbpLoaded) return;
  window.__kbpLoaded = true;

  var fmt = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });
  function money(cents) { return fmt.format(Math.max(0, cents) / 100); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function BundlePicker(el) {
    this.el = el;
    this.formId = el.dataset.formId;
    this.storeKey = 'kbp:' + (el.dataset.productType || 'default');
    this.tiles = Array.prototype.slice.call(el.querySelectorAll('[data-kbp-tile]'));
    this.error = el.querySelector('[data-kbp-error]');
    this.state = this.load();
    this.bind();
    this.restore();
  }

  BundlePicker.prototype.load = function () {
    try { return JSON.parse(sessionStorage.getItem(this.storeKey)) || {}; } catch (e) { return {}; }
  };
  BundlePicker.prototype.save = function () {
    try { sessionStorage.setItem(this.storeKey, JSON.stringify(this.state)); } catch (e) {}
  };

  BundlePicker.prototype.bind = function () {
    var self = this;
    this.tiles.forEach(function (tile) {
      var radio = tile.querySelector('.kbp-tile__radio');
      radio.addEventListener('change', function () { self.select(tile, true); });
      tile.querySelectorAll('.kbp-swatch__radio').forEach(function (sw) {
        sw.addEventListener('change', function () {
          self.state.second = self.state.second || {};
          self.state.second[tile.dataset.offer] = sw.value;
          self.save();
          self.updateTile(tile);
        });
      });
      // Any-size 2nd bag: size buttons switch the colour row; keep the same colour if that size has it
      tile.querySelectorAll('[data-kbp-size]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = tile.querySelector('[data-kbp-size-group="' + btn.dataset.kbpSize + '"]');
          if (!group) return;
          var cur = self.secondInput(tile);
          var colour = cur ? cur.dataset.colour : null;
          var pick = null;
          group.querySelectorAll('.kbp-swatch__radio:not([disabled])').forEach(function (r) {
            if (!pick && colour && r.dataset.colour === colour) pick = r;
          });
          if (!pick) pick = group.querySelector('.kbp-swatch__radio:not([disabled])');
          if (!pick) return;
          pick.checked = true;
          self.showSize(tile);
          self.state.second = self.state.second || {};
          self.state.second[tile.dataset.offer] = pick.value;
          self.save();
          self.updateTile(tile);
        });
      });
      // Pick-an-accessory bundles: product buttons switch the colour row, colour swatches pick the variant
      tile.querySelectorAll('.kbp-acc__radio').forEach(function (r) {
        r.addEventListener('change', function () { self.updateTile(tile); });
      });
      tile.querySelectorAll('[data-kbp-acc-product]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = tile.querySelector('[data-kbp-acc-group="' + btn.dataset.kbpAccProduct + '"]');
          var pick = group && group.querySelector('.kbp-acc__radio:not([disabled])');
          if (!pick) return;
          pick.checked = true;
          self.showAcc(tile);
          self.updateTile(tile);
        });
      });
      // Bag colour inside a bundle: select it here and keep the other bundle tiles in step
      tile.querySelectorAll('.kbp-main__radio').forEach(function (sw) {
        sw.addEventListener('change', function () {
          self.tiles.forEach(function (t) {
            if (t !== tile) {
              var match = t.querySelector('.kbp-main__radio[value="' + sw.value + '"]:not([disabled])');
              if (match) match.checked = true;
            }
            self.updateTile(t);
          });
        });
      });
    });
    // "Just this bag" tile: changing colour loads that colour's page; keep the open tile and 2nd colour
    this.el.querySelectorAll('[data-kbp-main-link]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (a.classList.contains('is-current')) { e.preventDefault(); return; }
        var tile = self.current;
        if (tile) {
          self.state.offer = tile.dataset.offer;
          var sec = self.secondInput(tile);
          if (sec) { self.state.second = self.state.second || {}; self.state.second[tile.dataset.offer] = sec.value; }
          self.save();
        }
      });
    });
    document.addEventListener('submit', this.onSubmit.bind(this), true);
  };

  BundlePicker.prototype.restore = function () {
    var self = this;
    // Second-bag colour remembered from another colour page
    var saved = this.state.second || {};
    this.tiles.forEach(function (tile) {
      var want = saved[tile.dataset.offer];
      if (want) {
        var sw = tile.querySelector('.kbp-swatch__radio[value="' + want + '"]:not([disabled])');
        if (sw) sw.checked = true;
      }
      self.showSize(tile);
      self.updateTile(tile);
    });
    var target = null;
    if (this.state.offer !== undefined) {
      target = this.tiles.filter(function (t) { return t.dataset.offer === self.state.offer; })[0];
    }
    if (!target) target = this.tiles[parseInt(this.el.dataset.preselect || '0', 10)] || this.tiles[0];
    target.querySelector('.kbp-tile__radio').checked = true;
    this.select(target, false);
  };

  BundlePicker.prototype.select = function (tile, remember) {
    this.tiles.forEach(function (t) { t.classList.toggle('is-selected', t === tile); });
    this.current = tile;
    var isBundle = !!tile.dataset.offer;
    document.documentElement.classList.toggle('kbp-bundle-active', isBundle);
    this.setButtonText(isBundle);
    this.hideError();
    if (remember) { this.state.offer = tile.dataset.offer; this.save(); }
  };

  BundlePicker.prototype.secondInput = function (tile) {
    return tile.querySelector('.kbp-swatch__radio:checked');
  };
  // Show the colour row (and highlight the size button) for the size of the chosen 2nd bag
  BundlePicker.prototype.showSize = function (tile) {
    var groups = tile.querySelectorAll('[data-kbp-size-group]');
    if (!groups.length) return;
    var sec = this.secondInput(tile);
    var g = sec ? sec.closest('[data-kbp-size-group]') : null;
    var size = g ? g.dataset.kbpSizeGroup : null;
    if (!size) return;
    groups.forEach(function (el) { el.hidden = el.dataset.kbpSizeGroup !== size; });
    tile.querySelectorAll('[data-kbp-size]').forEach(function (b) {
      var on = b.dataset.kbpSize === size;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };
  BundlePicker.prototype.accInput = function (tile) {
    return tile.querySelector('.kbp-acc__radio:checked');
  };
  // Show the colour row (and highlight the button) for the chosen accessory
  BundlePicker.prototype.showAcc = function (tile) {
    var acc = this.accInput(tile);
    var g = acc ? acc.closest('[data-kbp-acc-group]') : null;
    if (!g) return;
    var pid = g.dataset.kbpAccGroup;
    tile.querySelectorAll('[data-kbp-acc-group]').forEach(function (el) { el.hidden = el.dataset.kbpAccGroup !== pid; });
    tile.querySelectorAll('[data-kbp-acc-product]').forEach(function (b) {
      var on = b.dataset.kbpAccProduct === pid;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };
  BundlePicker.prototype.mainInput = function (tile) {
    return tile.querySelector('.kbp-main__radio:checked');
  };

  BundlePicker.prototype.updateTile = function (tile) {
    if (!tile.dataset.offer) return;
    var main = this.mainInput(tile);
    var mainPrice = main ? parseInt(main.dataset.price, 10) : parseInt(this.el.dataset.mainPrice, 10);
    var pct = parseInt(tile.dataset.pct || '0', 10);
    var addons = JSON.parse(tile.dataset.addons || '[]');
    var addonsTotal = addons.reduce(function (s, a) { return s + a.price; }, 0);
    var acc = this.accInput(tile);
    if (acc) addonsTotal += parseInt(acc.dataset.price, 10);
    var second = this.secondInput(tile);
    var secondPrice = second ? parseInt(second.dataset.price, 10) : 0;
    var full = mainPrice + addonsTotal + secondPrice;
    var keep = (100 - pct) / 100;
    var total = tile.dataset.scope === 'whole'
      ? Math.round(full * keep)
      : mainPrice + Math.round((addonsTotal + secondPrice) * keep);
    var saving = full - total;

    var priceEl = tile.querySelector('[data-kbp-price]');
    var wasEl = tile.querySelector('[data-kbp-was]');
    var saveEl = tile.querySelector('[data-kbp-save]');
    if (priceEl) priceEl.textContent = money(total);
    if (wasEl) wasEl.textContent = money(full);
    if (saveEl) saveEl.textContent = 'Save ' + money(saving);
    var nameEl = tile.querySelector('[data-kbp-second-name]');
    if (nameEl && second) nameEl.textContent = second.dataset.name;
    var mainNameEl = tile.querySelector('[data-kbp-main-name]');
    if (mainNameEl && main) mainNameEl.textContent = main.dataset.name;
    var accNameEl = tile.querySelector('[data-kbp-acc-name]');
    if (accNameEl && acc) accNameEl.textContent = acc.dataset.name;
  };

  BundlePicker.prototype.buttonTextEls = function () {
    var id = this.formId;
    return Array.prototype.slice.call(document.querySelectorAll(
      '#' + id + ' [data-add-to-cart-text], [form="' + id + '"] [data-add-to-cart-text]'
    ));
  };
  BundlePicker.prototype.setButtonText = function (isBundle) {
    this.buttonTextEls().forEach(function (el) {
      if (!el.dataset.kbpOriginal) el.dataset.kbpOriginal = el.textContent.trim();
      el.textContent = isBundle ? 'Add bundle to cart' : el.dataset.kbpOriginal;
    });
  };

  BundlePicker.prototype.showError = function (msg) {
    if (!this.error) return;
    this.error.textContent = msg;
    this.error.hidden = false;
  };
  BundlePicker.prototype.hideError = function () { if (this.error) this.error.hidden = true; };

  BundlePicker.prototype.onSubmit = function (e) {
    var form = e.target;
    // form.id can be shadowed by the hidden <input name="id">, so read the attribute
    if (!form || !form.getAttribute || form.getAttribute('id') !== this.formId) return;
    if (!this.current || !this.current.dataset.offer) return; // bag only: let the theme handle it

    e.preventDefault();
    e.stopImmediatePropagation();
    if (this.busy) return;

    var tile = this.current;
    var offer = tile.dataset.offer;
    var data = new FormData(form);
    var qty = Math.max(1, parseInt(data.get('quantity'), 10) || 1);
    var main = this.mainInput(tile);
    var mainId = main ? String(main.value) : String(data.get('id') || this.el.dataset.mainVariant);
    var props = { _bundle: offer };

    var lines = {};
    function add(id) {
      id = String(id);
      lines[id] = (lines[id] || 0) + qty;
    }
    add(mainId);
    JSON.parse(tile.dataset.addons || '[]').forEach(function (a) { add(a.id); });
    var acc = this.accInput(tile);
    if (tile.querySelector('[data-kbp-acc]') && !acc) {
      this.showError('Please choose your accessory.');
      return;
    }
    if (acc) add(acc.value);
    var second = this.secondInput(tile);
    if (tile.querySelector('[data-kbp-second]') && !second) {
      this.showError('Please choose a colour for your second bag.');
      return;
    }
    if (second) add(second.value);

    var items = Object.keys(lines).map(function (id) {
      return { id: parseInt(id, 10), quantity: lines[id], properties: props };
    });

    var self = this;
    var buttons = document.querySelectorAll('#' + this.formId + ' [type="submit"], [form="' + this.formId + '"][type="submit"]');
    this.busy = true;
    buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Sorry, something went wrong.');
        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:cart-drawer:show', { bubbles: true }));
        } else {
          window.location.href = root() + 'cart';
        }
      })
      .catch(function (err) { self.showError(err.message); })
      .then(function () {
        self.busy = false;
        buttons.forEach(function (b) { b.removeAttribute('aria-busy'); b.disabled = false; });
      });
  };

  function init() {
    document.querySelectorAll('[data-kbp]').forEach(function (el) {
      if (!el.__kbp) el.__kbp = new BundlePicker(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  // The sticky cart bar renders late: re-apply the bundle button label once everything has loaded
  window.addEventListener('load', function () {
    document.querySelectorAll('[data-kbp]').forEach(function (el) {
      var p = el.__kbp;
      if (p && p.current) p.setButtonText(!!p.current.dataset.offer);
    });
  });
})();
